const ProductShowcaseUX = () => {
    if($('.section-product-showcase').length <= 0) return null;

    $('.section-product-showcase').each(function() {
        const $parent = $(this);
        const $slider = $parent.find('.product-list');

        const $prevArrow = $parent.find('.custom-slider-arrow.prev');
        const $nextArrow = $parent.find('.custom-slider-arrow.next');
        
        const $artifactToggles = $parent.find('.artifact-toggle');
    
        const $ctaButtons = $parent.find('.product-detail .primary-btn');

        const slickOptions = {
            slidesToShow: 4,
            slidesToScroll: 1,
            ininite: true,
            dots: false,
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }

        if ($parent.hasClass('is-carousel')) {
            $slider.slick(slickOptions);
        }
        

        $artifactToggles.click(function() {
            $(this).toggleClass('active');
            $(this).closest('.artifact-column').find('.artifact-details').stop().fadeToggle();
        })
        
    $ctaButtons.on('mouseenter', function() {
        const $theBtn = $(this); 
        $theBtn.find('.btn-text').css('display', 'none');
        $theBtn.find('.product-price').css('display', 'block');
    }).on('mouseleave', function() {
        const $theBtn = $(this); 
        $theBtn.find('.product-price').css('display', 'none');
        $theBtn.find('.btn-text').css('display', 'block');
    })
    })
}

export default ProductShowcaseUX;